import React from 'react';
import Image from "../assets/loading.svg";

function Loader(props) {
    return (
        <img src={Image} alt="Loading" />
    );
}

export default Loader;